import useLanguageStore from "../store/languageStore";
import { translations } from "./translations";

export const useTranslation = () => {
  const language = useLanguageStore((state) => state.language);

  const t = (key, params = {}) => {
    const keys = key.split(".");
    let value = translations[language];
    
    for (const k of keys) {
      value = value?.[k];
    }
    
    // 如果找不到翻译，返回 key 或中文版本
    if (!value) {
      const zhValue = keys.reduce((obj, k) => obj?.[k], translations.zh);
      value = zhValue || key;
    }
    
    // 替换占位符
    if (params && typeof value === 'string') {
      Object.keys(params).forEach(paramKey => {
        value = value.replace(new RegExp(`\\{${paramKey}\\}`, 'g'), params[paramKey]);
      });
    }
    
    return value;
  };

  return { t, language };
};

